module.exports = __webpack_public_path__ + "img/guanli.62b684ec.jpg";